import React from "react";
import styled from 'styled-components';

import { Button } from "./Button";
import { HeroParagraph } from "../theme/typography";

const StyledContactBlock = styled.section`
	background: ${(props) => props.theme.colors.neutral10};
	border-top: 1px solid ${(props) => props.theme.colors.neutral8};
	color: ${(props) => props.theme.colors.neutral2};
`;

const ContentContainer = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding: 1.5rem;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		align-items: flex-end;
		flex-direction: row;
		justify-content: center;
	}

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		gap: 3rem;
		padding: 3rem;
	}
`;

const ContactOption = styled.div`
	box-sizing: border-box;
	flex: 1;
	max-width: 32rem;
`;

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-top: 2rem;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		display: flex;
	}
`;

const Heading = styled.h3`
	${(props) => props.theme.typography.headingL};
	margin: 1.5rem auto;
`;

const FlexButton = styled(Button)`
	flex: 0 0 auto;
`;

export class ContactBlock extends React.Component {

	render() {
		return (
			<StyledContactBlock id="contact">
				<ContentContainer>
					<ContactOption>
						<Heading>Check out my videos!</Heading>
						<HeroParagraph>Follow along with the development of Tressym frames in my two-minute shorts!</HeroParagraph>
						<ButtonContainer>
							<FlexButton label="TikTok" link="https://www.tiktok.com/@edwardfpv"/><FlexButton label="Youtube" link="https://www.youtube.com/@edwardFPV"/>
						</ButtonContainer>
					</ContactOption>
					<ContactOption>
						<Heading>Join our Discord!</Heading>
						<HeroParagraph>Ask&nbsp;questions, share your feedback, keep&nbsp;up with development news - be a part of Tressym's community!</HeroParagraph>
						<ButtonContainer>
							<FlexButton label="Accept invite" link="https://discord.gg/rRCda9KUWR"/>
						</ButtonContainer>
					</ContactOption>
					<ContactOption>
						<Heading>Tell me what you think!</Heading>
						<HeroParagraph>I'd love to hear your feedback on Tressym designs! What do you like, what would you change?</HeroParagraph>
						<ButtonContainer>
							<FlexButton label="Send email" link="mailto:contact@tressym.eu"/>
						</ButtonContainer>
					</ContactOption>
				</ContentContainer>
			</StyledContactBlock>
		);
	}
}